import { render, staticRenderFns } from "./mobileContent5.vue?vue&type=template&id=596dba16&scoped=true"
import script from "./mobileContent5.vue?vue&type=script&lang=js"
export * from "./mobileContent5.vue?vue&type=script&lang=js"
import style0 from "./mobileContent5.vue?vue&type=style&index=0&id=596dba16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596dba16",
  null
  
)

export default component.exports